/* eslint no-param-reassign: ["error", { "props": false }] */
/* eslint no-unused-vars: "off" */

import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '@/store';

Vue.use(VueRouter);


const router = new VueRouter({
  mode: 'history',
  base: '/beta/',
  routes: routes.map((route) => {
    const isPublic = route.isPublic || false;
    return {
      name: route.name,
      path: route.path,
      component: route.component,
      props: route.props,
      beforeEnter: route.beforeEnter,
      meta: {
        auth: route.auth || true,
        isPublic,
      },
    };
  }),
});

router.beforeEach((to, from, next) => {
  // if (to.meta.isPublic) {
  //   store.dispatch('common/updateLayout', 'PublicLayout');
  //   next();
  // } else if (!store.state.auth.token) {
  //   next('/login');
  // } else {
  //   store.dispatch('common/updateLayout', 'PrivateLayout');
  //   next();
  // }
  next();
});

export default router;
